// extracted by mini-css-extract-plugin
export var centerText = "_61-8";
export var container = "_61-0";
export var doughnutContainer = "_61-7";
export var legend = "_61-a";
export var legendItemColorDisplay = "_61-b";
export var legendItemLabel = "_61-d";
export var legendItemValue = "_61-c";
export var lg = "_61-5";
export var maxWidth = "_61-9";
export var md = "_61-4";
export var responsive = "_61-6";
export var sm = "_61-3";
export var xs = "_61-2";
export var xxs = "_61-1";